import { locationIdFormat } from "@redotech/redo-ids/ids";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Resolves a scanned tote barcode to the HANDED_OFF pick session the tote
 * belongs to. Returns null when:
 *   - the barcode doesn't match any tote at this location, or
 *   - the matched tote isn't currently assigned to a HANDED_OFF session
 *     (e.g. it's free, or assigned to an ACTIVE/PICKED session).
 *
 * Drives the scan-to-pickup path on the start-new-session page. The UI
 * uses the returned `toteIds` list to enforce multi-tote pickup: when one
 * tote of a multi-tote session is scanned, the picker must scan the rest
 * before they can complete the pickup.
 */
export const getHandoffByToteBarcode = {
  name: "getHandoffByToteBarcode" as const,
  input: z.object({
    barcode: z.string().max(255),
    locationId: locationIdFormat.schema,
  }),
  output: z
    .object({
      pickSessionId: zExt.objectId(),
      zoneId: z.string(),
      fulfillmentGroupId: zExt.objectId(),
      itemCount: z.number(),
      totes: z.array(
        z.object({
          toteId: zExt.objectId(),
          name: z.string(),
          barcode: z.string(),
        }),
      ),
    })
    .nullable(),
};
